<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ActiveFilterChip from './Filters/v3/ActiveFilterChip.vue';

const props = defineProps({
  widgets: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const showMenu = ref(false);
const activeFilterType = ref('');

const widgetOptions = computed(() => [
  {
    id: '',
    name: t('WIDGET_LOAD_REPORTS.ALL_WIDGETS'),
    type: 'widgets',
  },
  ...props.widgets.map(widget => ({
    id: widget.id,
    name: widget.name,
    type: 'widgets',
  })),
]);

const selectedWidgetName = computed(() => {
  if (!props.modelValue) {
    return t('WIDGET_LOAD_REPORTS.ALL_WIDGETS');
  }
  const widget = props.widgets.find(
    item => String(item.id) === String(props.modelValue)
  );
  return widget?.name || t('WIDGET_LOAD_REPORTS.SELECT_WIDGET');
});

const openDropdown = filterType => {
  activeFilterType.value = filterType;
  showMenu.value = !showMenu.value;
};

const closeDropdown = () => {
  showMenu.value = false;
  activeFilterType.value = '';
};

const selectWidget = item => {
  emit('update:modelValue', item.id === '' || item.id == null ? '' : item.id);
  closeDropdown();
};
</script>

<template>
  <div class="flex flex-col w-full gap-3 lg:flex-row print:hidden">
    <ActiveFilterChip
      :id="modelValue"
      filled
      menu-align="start"
      icon="i-lucide-message-circle"
      :name="selectedWidgetName"
      type="widgets"
      :options="widgetOptions"
      :active-filter-type="activeFilterType"
      :show-menu="showMenu"
      :placeholder="t('WIDGET_LOAD_REPORTS.SEARCH_WIDGET')"
      :show-clear-filter="false"
      enable-search
      @toggle-dropdown="openDropdown"
      @close-dropdown="closeDropdown"
      @add-filter="selectWidget"
    />
  </div>
</template>
